import { cn } from '../utils/cn'
import {
  formatThaiDatetimePartsFromDate,
  parseDatetimeInput,
} from '../utils/formatters'

const FORMATTED_DATETIME_RE = /^(.+?) \((\d{2}:\d{2})\)$/

function resolveThaiDatetimeParts(
  value: string | number | null | undefined,
): { dateLabel: string; timeLabel: string } | null {
  if (value == null || value === '' || value === '—') return null

  const text = String(value).trim()
  const formatted = text.match(FORMATTED_DATETIME_RE)
  if (formatted) {
    return { dateLabel: formatted[1], timeLabel: formatted[2] }
  }

  const date = parseDatetimeInput(value)
  if (!date) return null

  return formatThaiDatetimePartsFromDate(date)
}

export function ThaiDatetimeText({
  value,
  variant = 'table',
  layout = 'inline',
  className,
}: {
  value: string | number | null | undefined
  variant?: 'table' | 'drawer' | 'meta'
  layout?: 'inline' | 'stacked'
  className?: string
}) {
  const parts = resolveThaiDatetimeParts(value)
  if (!parts) {
    return <span className={cn('text-aera-lightslate', className)}>—</span>
  }

  const dateClass =
    variant === 'drawer'
      ? 'font-medium leading-6 text-aera-charcoal'
      : variant === 'meta'
        ? 'text-[11px] text-aera-gray'
        : 'font-medium leading-5 text-aera-gray'

  const timeClass =
    variant === 'drawer'
      ? 'text-xs font-medium leading-5 text-aera-lightslate'
      : variant === 'meta'
        ? 'text-[9px] font-medium text-aera-lightslate'
        : 'text-xxs font-medium leading-5 text-aera-lightslate'

  return (
    <span
      className={cn(
        'tabular-nums whitespace-nowrap',
        layout === 'stacked'
          ? 'inline-flex flex-col items-start gap-0'
          : 'inline-flex items-baseline gap-1',
        className,
      )}
    >
      <span className={dateClass}>{parts.dateLabel}</span>
      <span className={timeClass}>
        {layout === 'stacked' ? parts.timeLabel : `(${parts.timeLabel})`}
      </span>
    </span>
  )
}
